import { render, staticRenderFns } from "./teamMemberProfile.vue?vue&type=template&id=c1f8e612&"
import script from "./teamMemberProfile.vue?vue&type=script&lang=js&"
export * from "./teamMemberProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports